import { render } from "./SidebarMenu.vue?vue&type=template&id=01861a67&scoped=true"
import script from "./SidebarMenu.vue?vue&type=script&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&lang=js"

import "./SidebarMenu.vue?vue&type=style&index=0&id=01861a67&lang=scss&scoped=true"

import exportComponent from "/Users/giacomo/Developer/tandu/barbera/barberabilance-docs-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01861a67"]])

export default __exports__